import React from 'react';
import ReactDOM from 'react-dom';

import Preview from '../components/Preview';

export const render = (element, jsx) =>
  ReactDOM.render(<Preview>{jsx()}</Preview>, document.getElementById(element));



// WEBPACK FOOTER //
// ./src/utils/render.js